import type { AxiosResponse } from 'axios';
import axios from 'axios';
import type { TokenResponse } from '@getaccept/lib-shared/src/types/token-response';

export class AuthService {
  static async getToken() {
    return axios
      .get('/get/settings/token')
      .then((value: AxiosResponse<TokenResponse>) => value.data);
  }
}
